import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$67f4 from '/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as directusRuntime$9a53 from '/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/node_modules/@twago/cms/src/provider.js'

const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "directus",
  "domains": [],
  "alias": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$67f4, defaults: {} },
  ['directus']: { provider: directusRuntime$9a53, defaults: {"baseURL":"https://cms.talent-pool.com/assets","modifiers":{"format":"webp","withoutEnlargement":true}} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
